import { useRef } from 'react'

import { dealUserCount } from '../helper'
import { useCountStore } from '../store'

import { api } from '@/utils/api'
import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'

export function useUpdateUserCount() {
  const { update } = useCountStore()
  const { isSignIn } = useSessionInfo()
  const isSignInRef = useRef(isSignIn)
  const { refetch } = api.subUsage.getSubUsage.useQuery(
    {
      appName: 'App1',
    },
    {
      enabled: false,
      onSuccess: (data) => {
        update(dealUserCount(data))
      },
    },
  )
  isSignInRef.current = isSignIn
  return {
    updateUserCount: () => {
      if (!isSignInRef.current) return
      refetch()
    },
  } //未登录update失效
}
